<ion-grid>
	<ion-row>
		<ion-col size="12" class="p-16">
			<dx-data-grid
				id="gridContainer"
				[dataSource]="members"
				keyExpr="id"
				[allowColumnResizing]="true"
				[columnAutoWidth]="true"
				[showBorders]="true"
				*ngIf="members"
			>
				<dxi-column
					caption="Actions"
					dataField="id"
					[allowFiltering]="false"
					[allowSorting]="false"
					cellTemplate="cellTemplate"
				>
				</dxi-column>
				<dxi-column
					caption="Email"
					dataField="email"
					[allowFiltering]="false"
					[allowSorting]="false"
				>
				</dxi-column>
				<dxi-column
					caption="Name"
					dataField="name"
					[allowFiltering]="false"
					[allowSorting]="false"
				>
				</dxi-column>
				<div *dxTemplate="let d of 'cellTemplate'">
					<a
						appConfirmBox
						(learnDelete)="deleteMember(d.data.id)"
						title="Delete"
						subTitle="Are you sure you want to delete member ?"
						class="Body_S text-right cursor"
						>Delete</a
					>
				</div>

				<dxo-toolbar>
					<dxi-item location="before">
						<div *dxTemplate class="informer">
							<ion-button (click)="addNewMember()"
								><ion-icon name="add-outline"></ion-icon
							></ion-button>
						</div>
					</dxi-item>

					<dxi-item location="before">
						<div *dxTemplate class="informer">
							<p class="Heading_M">Add Member</p>
						</div>
					</dxi-item>
				</dxo-toolbar>
			</dx-data-grid>
		</ion-col>
	</ion-row>
</ion-grid>
